










import {Component, Prop, Vue} from 'vue-property-decorator'
import ButtonCommon from '@/components/lib/ButtonCommon.vue'
import IconCustom from "@/components/lib/IconCustom.vue";
import {IModalControlButton} from '@/entities'

@Component({
  components: {
    ButtonCommon,
    IconCustom
  }
})
export default class ModalBaseControl extends Vue {
  @Prop() readonly control!: IModalControlButton
  @Prop() readonly href?: string

  get download(): Object | undefined {
    const href = this.href;
    return href && this.control.type === "download" ? {
      href,
      target: '_blank',
    } : undefined;
  }

}
